import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import {
  joinMultiValueFilters,
  listQueryToApiParams,
} from '#/utils/listUrl/parseListSearchParams';

/**
 * 簽收單列表。
 * Query：`keyword`、`sign_receipt_no`、`status`、`sign_receipt_date_from`／`_to`、
 * `customer_name`、`contact_name`、`remark`、`sort`（snake 白名單）、`page`、`page_size`。
 *
 * @param {object} listQuery
 */
export async function fetchSignReceiptList(listQuery) {
  const { data: raw } = await request.get('/aftersales/sign-receipt', {
    params: listQueryToApiParams(joinMultiValueFilters(listQuery)),
  });
  return parseVer4ListResponse(raw);
}
